
import { Vue, Component } from 'vue-property-decorator';
import { getPrice, thousandSeparators } from '@/features/common/helpers';
import { CostBreakdownData } from '@/features/dashboard/types';

@Component
export default class CostStatisticsComponent extends Vue {
  get widgetData(): CostBreakdownData {
    return this.$store.getters.getWidgets.costBreakdown.data;
  }

  private getPrice = getPrice;

  private thousandSeparators = thousandSeparators;
}
